import React, { useState, useEffect } from "react";

const PeopleList = () => {
  const [peopleData, setPeopleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPeople = async () => {
      try {
        // Fetch from your backend API endpoint for people
        const response = await fetch(`${process.env.REACT_APP_API_URL}/person`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setPeopleData(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPeople();
  }, []); // Empty dependency array means this runs once on mount

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 to-purple-100 font-inter">
        <div className="text-xl font-semibold text-gray-700 animate-pulse">
          Loading people data...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-red-100 to-orange-100 font-inter">
        <div className="text-xl font-bold text-red-700 p-6 bg-white rounded-lg shadow-xl">
          Error: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="people-table-container p-8 bg-gradient-to-br from-blue-50 to-purple-50 min-h-screen font-inter flex flex-col items-center">
      <div className="table-responsive w-full max-w-6xl overflow-hidden rounded-2xl shadow-2xl border border-gray-200 bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gradient-to-r from-green-500 to-teal-600 text-white shadow-md">
            <tr>
              <th
                scope="col"
                className="px-6 py-4 text-left text-sm font-semibold uppercase tracking-wider rounded-tl-2xl"
              >
                Name
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-left text-sm font-semibold uppercase tracking-wider"
              >
                Email
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-left text-sm font-semibold uppercase tracking-wider rounded-tr-2xl"
              >
                Website
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {peopleData.length > 0 ? (
              peopleData.map((person, index) => (
                <tr
                  key={index}
                  className="hover:bg-blue-50 transition-all duration-300 ease-in-out odd:bg-gray-50"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-base font-medium text-gray-900">
                    {person.Name || "-"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-base text-blue-700">
                    {person.Email && person.Email !== "-" ? (
                      <a
                        href={`mailto:${person.Email}`}
                        className="hover:underline hover:text-blue-800 transition-colors duration-200"
                      >
                        {person.Email}
                      </a>
                    ) : (
                      <span className="text-gray-500">-</span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-base text-purple-700">
                    {person.Website && person.Website !== "-" ? (
                      <a
                        href={
                          person.Website.startsWith("http")
                            ? person.Website
                            : `http://${person.Website}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline hover:text-purple-800 transition-colors duration-200"
                      >
                        {person.Website}
                      </a>
                    ) : (
                      <span className="text-gray-500">-</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="3"
                  className="px-6 py-6 text-center text-gray-500 text-lg"
                >
                  No people data available. Please check your database
                  connection.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PeopleList;
